export default {
  scenes: {
    lateNightVenue: {
      beats: {
        lastMinutePreparations: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: '...',
              choices: [
                {
                  text: 'Stay Professional',
                  next: {
                    scene: 'lateNightVenue',
                    beat: 'stayProfessional'
                  }
                },
                {
                  text: 'Show Concern',
                  next: {
                    scene: 'lateNightVenue',
                    beat: 'showConcern'
                  }
                }
              ]
            }
          ]
        },
        stayProfessional: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Everything is ready for tomorrow. You should get some rest.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Right. It\'s just… a lot to take in.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'It\'s normal to have doubts before a big life change.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: 'What if it\'s more than just doubts?'
            }
          ],
          next: {
            scene: 'almostTouch',
            beat: 'unspokenTension'
          }
        },
        showConcern: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'You seem… unsettled. Is everything okay?'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'sad',
              text: 'Honestly? I don\'t know.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'It\'s normal to have doubts before a big life change.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: 'What if it\'s more than just doubts?'
            }
          ],
          next: {
            scene: 'almostTouch',
            beat: 'unspokenTension'
          }
        }
      }
    },
    almostTouch: {
      beats: {
        unspokenTension: {
          events: [
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.3
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: '...',
              choices: [
                {
                  text: 'Step Back',
                  next: {
                    scene: 'almostTouch',
                    beat: 'stepBack'
                  }
                },
                {
                  text: 'Hold Eye Contact',
                  next: {
                    scene: 'almostTouch',
                    beat: 'holdEyeContact'
                  }
                }
              ]
            }
          ]
        },
        stepBack: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'You should get some rest. Tomorrow is a big day.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: 'Right. Tomorrow.'
            }
          ],
          next: {
            scene: 'almostTouch',
            beat: 'hesitantGoodbye'
          }
        },
        holdEyeContact: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'You\'re overthinking.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: 'Maybe. Or maybe I\'m thinking clearly for the first time.'
            }
          ],
          next: {
            scene: 'almostTouch',
            beat: 'hesitantGoodbye'
          }
        },
        hesitantGoodbye: {
          events: [
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Goodnight, Daniel.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Goodnight, Isabelle.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'weddingPlans',
            beat: 'finalTouches'
          }
        }
      }
    },
    weddingPlans: {
      beats: {
        finalTouches: {
          events: [
            {
              type: 'showLocation',
              locationId: 'bridalSuite'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: '...',
              choices: [
                {
                  text: 'Encourage Emily\'s Excitement',
                  next: {
                    scene: 'weddingPlans',
                    beat: 'encourageEmily'
                  }
                },
                {
                  text: 'Keep Conversations Brief',
                  next: {
                    scene: 'weddingPlans',
                    beat: 'keepBrief'
                  }
                }
              ]
            }
          ]
        },
        encourageEmily: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'happy',
              text: 'You look absolutely radiant. This will be a perfect day.'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'I can\'t wait to see Daniel at the altar.'
            }
          ],
          next: {
            scene: 'weddingPlans',
            beat: 'hiddenConflict'
          }
        },
        keepBrief: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Everything is in place. You\'ll have a seamless wedding.'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'thinking',
              text: 'You seem quiet today. Everything okay?'
            }
          ],
          next: {
            scene: 'weddingPlans',
            beat: 'hiddenConflict'
          }
        },
        hiddenConflict: {
          events: [
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'I know this is the right decision. Daniel and I are meant to be.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Of course. You two are perfect for each other.'
            },
            {
              type: 'showNarration',
              text: '(Then why does this feel like a lie?)'
            }
          ],
          goToChapter: {
            chapter: 'chapter3'
          }
        }
      }
    }
  }
}
